// extracted by mini-css-extract-plugin
module.exports = {"contactInfo":"styles_contactInfo__W_KO5","email":"styles_email__1AYO4","website":"styles_website__2SiMn"};